module.exports = __webpack_public_path__ + "img/graphic_design.2f208e3d.jpg";